import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { I18n } from 'aws-amplify';
import '../CancelDialog.css'
import { onClickCloseTab } from '../handler/ProjectManagementHandler';

export default function CancelTabsDialog({argsAll}) {
    const onCloseDialogReject = (event, reason) => {
        argsAll.setIsConfirmCancelTabs(false);
    };
    return (
        <Dialog
            open={argsAll.isConfirmCancelTabs}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">{I18n.get('COMMSG043')}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    onClick={() => onClickCloseTab(argsAll)}
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree"
                >
                    {I18n.get('COMBTN002')}
                </Button>

                <Button
                    variant="contained"
                    className="btn-light btn-hg32"
                    onClick={onCloseDialogReject}
                >
                    {I18n.get('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
